(function () {
	'use strict';

	angular.module('app.core')
		.service('procurementTaskService', procurementTaskService);

	procurementTaskService.$inject = ['$http', '$q', 'URLS', '$experiments', 'storeService'];

	function procurementTaskService($http, $q, URLS, $experiments, storeService) {
		var iconTooltip = {
			'None': 'No task, click to add task',
			'Open': 'Task status is Open, click to edit task',
			'Fixed': 'Task status is Fixed, click to edit task',
			'Review Later': 'Task status is Review Later, click to edit task',
			'Unable to Fix': 'Task status is Unable to Fix, click to edit task'
		};

		var iconMap = {
			'None': 'fa fa-circle task-status-none',
			'Open': 'fa fa-circle task-status-open',
			'Fixed': 'fa fa-circle task-status-fixed',
			'Review Later': 'fa fa-circle-o task-status-review-later',
			'Unable to Fix': 'fa fa-circle task-status-unable-to-fix',
			'Expired': 'fa fa-circle task-status-expired'
		};

		return {
			getCategories: getCategories,
			addCategory: addCategory,
			getStatuses: getStatuses,
			getIAStatuses: getIAStatuses,
			getAction: getAction,
			addComment: addComment,
			addAction: addAction,
			getUsers: getUsers,
			deleteComment: deleteComment,
			deleteAction: deleteAction,
			getActionByCode: getActionByCode,
			addWatcher: addWatcher,
			removeWatcher: removeWatcher,
			getEmailSuffix: getEmailSuffix,
			patchTask: patchTask,
			updateInventoryActionUnableToFixCategory: updateInventoryActionUnableToFixCategory,
			iconTooltip: iconTooltip,
			iconMap: iconMap,
			findExistingCategory: findExistingCategory,
			getCommentsForAction: getCommentsForAction,
			updateCategoryStatus:updateCategoryStatus,
			mergeCategories: mergeCategories
		};

		function deleteAction(id, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions/id/' + id;
			return $http.delete(URLS.host + url)
				.then(deleteActionComplete)
				.catch(deleteActionFailed);

			function deleteActionComplete(response) {
				return response.data;
			}

			function deleteActionFailed(error) {
				return undefined;
			}
		}

		function deleteComment(id, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions/Comment/id/' + id;
			return $http.delete(URLS.host + url)
				.then(deleteCommentComplete)
				.catch(deleteCommentFailed);

			function deleteCommentComplete(response) {
				return response.data;
			}

			function deleteCommentFailed(error) {
				return error;
			}
		}

		function addAction(action, dateForLogging, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions?dateForLogging=' + encodeURIComponent(dateForLogging);
			return $http.put(URLS.host + url, action)
				.then(addActionComplete)
				.catch(addActionFailed);

			function addActionComplete(response) {
				return response.data;
			}

			function addActionFailed(error) {
				//Conflict
				if (error.status == 409) {
					return {
						'error': 'Conflict'
					};
				}
				return undefined;
			}
		}

		function addCategory(category, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions/Categories';
			return $http.put(URLS.host + url, category)
				.then(addCategoryComplete)
				.catch(addCategoryFailed);

			function addCategoryComplete(response) {
				return response;
			}

			function addCategoryFailed(error) {
				return error;
			}
		}

		function updateCategoryStatus(factoryNdx, categories) {
			var url = URLS.prefix + factoryNdx + '/Actions/Categories/status';
			return $http.put(URLS.host + url, categories)
				.then(updateCategoryStatusComplete)
				.catch(updateCategoryStatusFailed);

			function updateCategoryStatusComplete(response) {
				return response;
			}

			function updateCategoryStatusFailed(error) {
				return error;
			}
		}

		function mergeCategories(factoryNdx, categoryNdx, categoryIdsToBeMerged) {
			var url = URLS.prefix + factoryNdx + '/Actions/Categories/merge';
			var merge = {
				'categoryNdx': categoryNdx,
				'categoryIdsToBeMerged': categoryIdsToBeMerged.toString()
			};
			return $http.put(URLS.host + url, merge)
				.then(updateCategoryStatusComplete)
				.catch(updateCategoryStatusFailed);

			function updateCategoryStatusComplete(response) {
				return response;
			}

			function updateCategoryStatusFailed(error) {
				return error;
			}
		}

		function addComment(comment, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions/Comment';
			return $http.put(URLS.host + url, comment)
				.then(addCommentComplete)
				.catch(addCommentFailed);

			function addCommentComplete(response) {
				return response.data;
			}

			function addCommentFailed(error) {
				return error;
			}
		}

		function getAction(itemNdx, factoryNdx, multipleTasks) {
			var url = URLS.prefix + factoryNdx + '/Actions/itemNdx/' + itemNdx;
			if (multipleTasks) {
				url += '?multipleTasks=true';
			}
			return $http.get(URLS.host + url)
				.then(getActionComplete)
				.catch(getActionFailed);

			function getActionComplete(response) {
				return response.data;
			}

			function getActionFailed(error) {
				return undefined;
			}
		}

		function getActionByCode(itemCode, factoryNdx, multipleTasks) {
			// itemCode is sent hex-encoded to avoid CloudFront WAF SQLi rules
			// flagging itemCodes that contain `--`. The server hex-decodes the
			// itemCode query param. See ApiUtils.hexToString.
			var url = URLS.prefix + factoryNdx + '/Actions/itemCode?itemCode=' + storeService.toHex(itemCode);
			if (multipleTasks) {
				url += '&multipleTasks=true';
			}
			return $http.get(URLS.host + url)
				.then(getActionComplete)
				.catch(getActionFailed);

			function getActionComplete(response) {
				return response.data;
			}

			function getActionFailed(error) {
				return undefined;
			}
		}

		function getCommentsForAction(taskId, factoryNdx) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/Actions/' + taskId + '/Comments';
			var canceller = $q.defer();
			var cancel = function () {
				canceller.promise.isUserCancelled = true;
				canceller.resolve('Cancelled');
			};
			var promise = $http.get(url, {
				timeout: canceller.promise
			})
				.then(getCommentsForActionComplete)
				.catch(getCommentsForActionFailed);

			return {
				promise: promise,
				cancel: cancel
			};

			function getCommentsForActionComplete(response) {
				return response;
			}

			function getCommentsForActionFailed(error) {
				return error;
			}
		}

		function getCategories(factoryNdx, itemNdx, archivedCategoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions/Categories';
			var hasItemNdx = false;
			if (typeof itemNdx !== 'undefined' && itemNdx > 0) {
				hasItemNdx = true;
				url += '?itemNdx=' + itemNdx;
			}
			if (typeof archivedCategoryNdx !== 'undefined' && archivedCategoryNdx) {
				url += (!hasItemNdx ? '?': '&') + 'archivedCategoryNdx=' + archivedCategoryNdx;
			}
			return $http.get(URLS.host + url)
				.then(getCategoriesComplete)
				.catch(getCategoriesFailed);

			function getCategoriesComplete(response) {
				return response.data;
			}

			function getCategoriesFailed(error) {
				return [];
			}
		}

		function getUsers(factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/Actions/Users';
			return $http.get(URLS.host + url)
				.then(getUsersComplete)
				.catch(getUsersFailed);

			function getUsersComplete(response) {
				return response.data;
			}

			function getUsersFailed(error) {
				return [];
			}
		}

		function getStatuses(factoryNdx) {
			var url = String.format(URLS.host + URLS.actionStatuses, factoryNdx);
			return $http.get(url)
				.then(getStatusesComplete)
				.catch(getStatusesFailed);

			function getStatusesComplete(response) {
				return response.data;
			}

			function getStatusesFailed(error) {
				return [];
			}
		}

		function getIAStatuses(factoryNdx) {
			var url = '2/Dimensions/factndx/' + factoryNdx + '/InventoryActionTaskStatuses?includeReviewLater=true';
			return $http.get(URLS.host + url)
				.then(getIAStatusesComplete)
				.catch(getIAStatusesFailed);

			function getIAStatusesComplete(response) {
				return response.data;
			}

			function getIAStatusesFailed(error) {
				return [];
			}
		}

		function addWatcher(factoryNdx, taskId, userId, quiet) {
			var url = String.format(URLS.host + URLS.taskWatcher, factoryNdx);
			var watcher = { actionNdx: taskId, userNdx: userId };
			return $http.post(url, watcher, {
				ignoreLoadingBar: true,
				params: {
					quiet: quiet ? 'true' : undefined
				}
			})
				.then(addWatcherSuccess)
				.catch(addWatcherFailed);

			function addWatcherSuccess(response) {
				return response.data;
			}

			function addWatcherFailed(error) {
				return undefined;
			}
		}

		function removeWatcher(factoryNdx, taskId, userId, quiet) {
			var url = String.format(URLS.host + URLS.taskWatcherDelete, factoryNdx, taskId, userId);
			return $http.delete(url, {
				ignoreLoadingBar: true,
				params: {
					quiet: quiet ? 'true' : undefined
				}
			})
				.then(removeWatcherSuccess)
				.catch(removeWatcherFailed);

			function removeWatcherSuccess(response) {
				return response.data;
			}

			function removeWatcherFailed(error){
				return undefined;
			}
		}

		function getEmailSuffix(factoryNdx) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/FactoryGeneralSettings';
			return $http.get(url)
				.then(getEmailSuffixComplete)
				.catch(getEmailSuffixFailed);

			function getEmailSuffixComplete(response) {
				if (!response || !response.data)
					return undefined;
				return response.data.emailSuffix;
			}

			function getEmailSuffixFailed(error) {
				return undefined;
			}
		}

		function updateInventoryActionUnableToFixCategory(factoryNdx, inventoryActionId, categoryId) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/InventoryActions/' + inventoryActionId + '/UnableToFixCategory/' + categoryId;
			return $http.put(url)
				.then(updateInventoryActionUnableToFixCategorySuccess)
				.catch(updateInventoryActionUnableToFixCategoryFailed);

			function updateInventoryActionUnableToFixCategorySuccess(response) {
				return response;
			}

			function updateInventoryActionUnableToFixCategoryFailed(error) {
				return error;
			}
		}

		function patchTask(factoryNdx, taskId, taskObj) {
			return $http.patch(URLS.host + URLS.prefix + factoryNdx + '/Actions/' + taskId, taskObj)
				.then(patchTaskSuccess)
				.catch(patchTaskFailed);
			
			function patchTaskSuccess(response) {
				return response;
			}

			function patchTaskFailed(error) {
				return error;
			}
		}

		function findExistingCategory(categoryList, category) {
			var matchString = category.name.toUpperCase();
			return _.find(categoryList, function(cat) {
				return cat.name.toUpperCase() === matchString;
			});

		}
	}
})();
